let controllers = []

export function addController(controller) {
  controllers.push(controller)
}

export function removeController(id) {
  controllers = controllers.filter(el => el.id !== id)
}

export function signalAbortController() {
  controllers.forEach(el => el.controller.abort())
}
